import React from "react";

import { Box, Chip, Typography } from "@mui/material";
import { makeStyles, withStyles } from "tss-react/mui";

import { Maybe } from "@/gql/graphql";
import KcalIcon from "@components/Icons/KcalIcon";

const useStyles = makeStyles()({
  badge: {
    borderRadius: 0,
  },
});

const StyledKcalIcon = withStyles(KcalIcon, {
  root: {
    marginTop: "3px",
    marginRight: "6px",
    width: "18px",
    height: "18px",
  },
});

type NameProps = {
  name: Maybe<string> | undefined;
  recommendedCalories: number | undefined;
  isCurrentPlan: boolean;
};

const Name: React.FC<NameProps> = ({
  name,
  recommendedCalories,
  isCurrentPlan,
}) => {
  const { classes } = useStyles();
  return (
    <Box
      marginLeft={3}
      display="flex"
      flexDirection="column"
      justifyContent="center"
    >
      <Box
        display="flex"
        flexDirection="row"
        justifyContent={{ xs: "flex-start", md: "space-between" }}
        alignItems="center"
      >
        <Typography variant="subtitle1" color="textPrimary">
          {name}
        </Typography>
        {isCurrentPlan && (
          <Chip
            label="Current"
            size="small"
            className={classes.badge}
            sx={{
              marginLeft: { xs: 1.5, md: 4 },
              backgroundColor: "secondary.main",
              color: "common.white",
            }}
          />
        )}
      </Box>
      <Box display="flex" flexDirection="row">
        <StyledKcalIcon />

        <Typography variant="subtitle1" color="textPrimary">
          {recommendedCalories ?? "No recommended calories yet"}
        </Typography>

        <Typography
          variant="subtitle1"
          color="textSecondary"
          style={{ marginLeft: "3px" }}
        >
          {recommendedCalories != undefined ? "kcal" : ""}
        </Typography>
      </Box>
    </Box>
  );
};

export default Name;
